module.exports = __webpack_public_path__ + "img/blec.4857003f.png";